import { Component, type ReactNode } from "react";
import { Alert, Button, Center, Code, Stack } from "@mantine/core";

interface State {
  error: Error | null;
}

/**
 * Root error boundary. The app throws on invalid state instead of masking it; this renders the
 * exception instead of an empty page. It does not recover - reloading starts over.
 */
export default class AppErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  render() {
    const { error } = this.state;
    if (error === null) return this.props.children;

    return (
      <Center mih="100vh" p="md">
        <Stack maw={720} w="100%">
          <Alert color="red" title="Application error">
            {error.message}
          </Alert>
          {error.stack && (
            <Code block style={{ maxHeight: 320, overflow: "auto" }}>
              {error.stack}
            </Code>
          )}
          <Button variant="light" onClick={() => window.location.reload()}>
            Reload
          </Button>
        </Stack>
      </Center>
    );
  }
}
